import React from 'react';
import {Segment, Header, Button, Loader} from 'semantic-ui-react';
import { Link } from 'react-router-dom';

const HealthVideoView = (props) => {
    const selectedVideoDetail = props.videos[0];
    if (!selectedVideoDetail) { return <Loader active />; }
    const {
        snippet,
        contentDetails
    } = selectedVideoDetail;
    const {
        videoId
    } = contentDetails;
    const {
        description
    } = snippet;
    return (
        <div>
            <Header as='h2' attached='top' block>
                View Video
            </Header>
            <Link to="/app/healtharticles">
                <Button attached>
                    Go back to article listing
                </Button>
            </Link>
            <Segment attached>
                <iframe 
                    width="100%" 
                    height="500" 
                    src={`https://www.youtube.com/embed/${videoId}`} 
                    frameBorder="0" 
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
                    allowFullScreen
                />
                <p>
                    {description}
                </p>
            </Segment>
        </div>
    );
}

export default HealthVideoView;